/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import isDestroyed from 'cio/utils/is-destroyed';
import { tracked } from '@glimmer/tracking';

interface TooltipIfTruncatedArgs {
  content?: string;
  tooltipTriggerClassnames?: string;
}

export default class TooltipIfTruncated extends Component<TooltipIfTruncatedArgs> {
  @tracked isContentTruncated = false;

  container: HTMLElement | null = null;

  @action
  checkContentTruncated() {
    let { container } = this;

    if (isDestroyed(this) || container == null) {
      return;
    }

    // This tells us whether the content has been truncated (with ellipsis)
    // through CSS. If yes, we'll add a tooltip with the full content.
    // https://stackoverflow.com/a/9541579
    let isContentTruncated = container.scrollWidth > container.clientWidth;

    // Only set if value has changed to avoid unnecessary re-renders
    if (isContentTruncated !== this.isContentTruncated) {
      this.isContentTruncated = isContentTruncated;
    }
  }

  @action
  didInsertTrigger(element: HTMLElement) {
    this.container = element;
    this.checkContentTruncated();
  }
}
